import { PropTypes } from 'prop-types';
import React from 'react';
import DocumentUploadModal from './DocumentUploadModal';
import InfoContainer from '../InfoContainer/InfoContainer';
import { AccentLargeText } from '../../css/fonts';
import { CenteredContainer, GridRow } from '../../css/styledComponents.styles';
import { STable } from '@/customComponents/BuildingBlocks/SortableTable/SortableTable';

export default class DocumentContainer extends React.Component {
  static propTypes = {
    documents: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        formName: PropTypes.string,
        detail: PropTypes.string,
        version: PropTypes.string,
        dateSigned: PropTypes.string
      })
    ).isRequired,
    onSubmit: PropTypes.func.isRequired,
    title: PropTypes.string
  };

  static defaultProps = {
    title: ''
  };

  rowMap = {
    name: {
      id: 'name',
      label: 'Form Name'
    },
    detail: {
      id: 'detail',
      label: 'Detail'
    },
    version: {
      id: 'version',
      label: 'Document Version'
    },
    dateSigned: {
      id: 'dateSigned',
      label: 'Date Signed'
    },
    view: {
      id: 'view'
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }

  buildRows = (
    document = {
      id: '',
      formName: '',
      detail: '',
      version: '',
      dateSigned: ''
    }
  ) => ({
    id: document.id,
    columns: [
      {
        value: document.formName,
        columnId: this.rowMap.name.id,
        label: STable.columnLabel(document.formName)
      },
      {
        value: document.detail,
        columnId: this.rowMap.detail.id,
        label: STable.columnLabel(document.detail)
      },
      {
        value: document.version,
        columnId: this.rowMap.version.id,
        label: STable.columnLabel(document.version)
      },
      {
        value: document.dateSigned,
        columnId: this.rowMap.dateSigned.id,
        label: STable.columnLabel(new Date(document.dateSigned).toLocaleDateString())
      },
      {
        value: '',
        columnId: this.rowMap.view.id,
        label: <a href="">View</a>
      }
    ]
  });

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  submitModal = (documentInfo) => {
    const { onSubmit } = this.props;
    onSubmit(documentInfo);
    this.closeModal();
  };

  render() {
    const { documents, title } = this.props;
    const { isModalOpen } = this.state;

    return (
      <>
        <InfoContainer
          noPadding
          leftSubBarContents={[{ type: 'label', props: { label: title } }]}
          rightSubBarContents={[
            {
              type: 'tabBarButton',
              props: {
                label: 'UPLOAD NEW',
                btnTheme: 'primary',
                onClick: this.openModal
              }
            }
          ]}
        >
          <STable
            defaultSort={this.rowMap.name.id}
            columns={Object.values(this.rowMap)}
            rows={documents.map((user) => this.buildRows(user))}
          />
          {documents.length === 0 && (
            <GridRow>
              <CenteredContainer>
                <AccentLargeText>No Documents Uploaded</AccentLargeText>
              </CenteredContainer>
            </GridRow>
          )}
        </InfoContainer>
        {isModalOpen && <DocumentUploadModal closeModal={this.closeModal} submitDocument={this.submitModal} />}
      </>
    );
  }
}
